import React from 'react';
import useDataDocumentItems from '../../hooks/useDataDocumentItems';
import { useParams } from 'react-router-dom';
import { Box, Divider } from '@mui/material';
import Card from './Card';
import { useDocuments } from '../../store/documents.store';
import { useCart } from '../../store/cart.store';
import CatalogCard from '../Catalog/CatalogCard';
import CardSkeleton from './CardSkeleton';
import NewPreloader from '../Common/NewPreloader';

const List = () => {
    const { id } = useParams();
    const { data, isLoading } = useDataDocumentItems(id!);
    const { openEdit, loading } = useDocuments();
    const { cart } = useCart();
    return (
        <Box>
            {(loading || isLoading) ? (
                <Box  sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:'100px'}}>
                    <NewPreloader/>
                </Box>
            ) : (
                openEdit ? (
                    <>
                        {cart?.map((item, index) => (
                            <Box key={item.product.id}>
                                <CatalogCard item={item.product} />
                                {index < cart.length - 1 && <Divider />} 
                            </Box>
                        ))}
                    </>
                ) : (
                    <>
                        {data?.items?.map((item, index) => (
                            <Box key={index}>
                                <Card item={item} />
                                {index < data.items.length - 1 && <Divider />} 
                            </Box>
                        ))}
                    </>
                )
            )}
        </Box>
    );
};

export default List;
